import ApiService from '@/common/api.service';

export const TooltipService = {
    get(slug) {
        return ApiService.query(`/tooltip/${slug}`);
    }
};
